// Vỏ app: màn · topbar · rail · nav · trang con · cửa sổ · dải hỏi · toast (UI_SPEC §2–§4).
import type { JSX } from 'preact';
import { useEffect } from 'preact/hooks';
import { activeTab, ask, closeSubpage, closeWindows, resolveAsk, subpage, windows } from '@state/modules/ui';
import { ScreenHost } from '../screens/ScreenHost';
import { Topbar } from './Topbar';
import { Nav } from './Nav';
import { Rail } from './Rail';
import { SubpageHost } from './Subpage';
import { WindowHost } from './Window';
import { AskStripHost } from './AskStrip';
import { ToastHost } from './Toast';
import { OpeningHost } from './Opening';
import { ReturnHost } from './ReturnScreen';
import { LootFxHost } from './LootFx';
import { RevealHost } from './RevealRite';

/** Esc đóng lớp trên cùng: dải hỏi → cửa sổ → trang con. */
function onKey(e: KeyboardEvent): void {
  if (e.key !== 'Escape') return;
  if (ask.value) resolveAsk(false);
  else if (windows.value.length > 0) closeWindows();
  else if (subpage.value) closeSubpage();
}

export function App(): JSX.Element {
  useEffect(() => {
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  return (
    <div class="app" data-tab={activeTab.value}>
      <div class="app-dom">
        <ScreenHost />
        <Topbar />
        <Rail />
        <Nav />
        <SubpageHost />
        <WindowHost />
        <AskStripHost />
        <ToastHost />
        <LootFxHost />
        <ReturnHost />
        <RevealHost />
        <OpeningHost />
      </div>
    </div>
  );
}
